import { noParameters, singleParameter } from '/b2b/common/helpers/Redux/parameterize';

import { DOMAIN } from './Auth.constants';
import { buildActionCreators } from '/b2b/common/helpers/Redux/buildActionCreators';
import { makeActionTypes } from '/b2b/common/helpers/Redux/makeActionTypes';
import { makeAsyncEvents } from '/b2b/common/helpers/Redux/makeAsyncEvents';

export const events = {
    logout: noParameters,
    changeUserRole: singleParameter,
    updateAuthState: singleParameter,
    selectMfa: singleParameter,
    removeMfa: singleParameter,
    refreshTokens: singleParameter,
};

export const asyncEvents = makeAsyncEvents([
    'signUp',
    'signIn',
    'signInFederated',
    'forgotPassword',
    'confirmSignUp',
    'confirmSignIn',
    'resendSignUpCode',
    'verifyEmail',
    'verifyPhone',
    'verifyTotp',
    'resendCode',
    'resendEmailVerificationCode',
    'resendPhoneVerificationCode',
    'resetPassword',
    'resetTemporaryPassword',
    'completeNewPassword',
    'fetchCustomer',
    'changePassword',
    'addMfa',
    'setPreferredMfa',
    'setupPhone',
    'setupTotp',
    'updateUserAttributes',
]);

export const contextEvents = makeAsyncEvents(['fetchSignInContext']);
export const mfaEvents = makeAsyncEvents(['getMfaOptions']);

export const types = makeActionTypes(
    [
        ...Object.keys(events),
        ...Object.keys(asyncEvents),
        ...Object.keys(contextEvents),
        ...Object.keys(mfaEvents),
    ],
    DOMAIN
);

export default buildActionCreators(
    {
        ...events,
        ...asyncEvents,
        ...contextEvents,
        ...mfaEvents,
    },
    types
);
